export default "__VITE_ASSET__pAtC60jy__"